import { jsxs as l, jsx as i } from "react/jsx-runtime";
import C from "../../../svg-icon/svg-icon.component.js";
function e(t) {
  return /* @__PURE__ */ l(
    C,
    {
      width: "86",
      height: "38",
      viewBox: "0 0 86 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ l("g", { clipPath: "url(#DefaultBrandMarkPositive-clip0_34574_1971)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0.0859375 4.10947H6.85178V10.8384H15.087V16.8026H6.85178V27.0763C6.85178 29.2984 7.66887 30.7351 10.5106 30.7351H15.087V36.6993H10.5106C2.066 36.6985 0.0859375 32.0054 0.0859375 26.6754V4.10947Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M17.9082 4.10945C17.9082 1.32776 20.2753 0.0497742 22.0177 0.0497742C24.2329 0.0497742 26.0765 1.82041 26.0765 4.10945C26.0765 6.0629 24.4784 8.21891 22.0177 8.21891C19.2634 8.21891 17.9082 5.80285 17.9082 4.10945ZM18.6103 36.6985V10.8384H25.3761V36.6985H18.6103Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M53.581 15.5238C51.8627 12.3172 48.5944 10.3363 44.46 10.3363C39.7043 10.3363 37.1724 13.2133 36.3913 14.2132V10.8384H29.6255V36.6985H36.3913V22.2149C36.3913 19.9027 37.6616 18.1098 39.2734 17.2283C40.1583 16.7442 41.1531 16.5013 42.2551 16.5013C43.4241 16.5013 44.4515 16.7442 45.3372 17.2283C47.0443 18.1613 48.1189 19.901 48.1189 22.2149V36.6985H54.8848V21.0116C54.8848 18.9741 54.4505 17.1451 53.5819 15.5238H53.581Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M65.7221 26.4746C65.1625 24.922 64.8758 22.4312 66.1693 20.0598C67.3468 17.9003 69.4702 16.552 72.0828 16.552C75.0001 16.552 76.9802 18.1965 77.9964 20.0598C79.2315 22.3248 79.0341 24.8361 78.4436 26.4746H85.66C85.8497 25.4979 86.6041 21.1592 84.085 16.9528C81.7059 12.9798 77.3896 10.3372 72.082 10.3372C66.4782 10.3372 62.2924 13.2527 60.0789 16.9528C57.5718 21.1429 58.3022 25.4352 58.5039 26.4746H65.7212H65.7221Z",
              fill: "#FF5D47"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M60.3192 30.9849C62.4589 34.3416 66.4293 37.1997 72.082 37.1997C77.0841 37.1997 81.3746 34.8583 83.8448 30.9849H60.3184H60.3192Z",
              fill: "#FF5D47"
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_34574_1971", children: /* @__PURE__ */ i("rect", { width: "85.9999", height: "37.2495", fill: "white" }) }) })
      ]
    }
  );
}
export {
  e as DefaultBrandMarkPositiveLogo
};
//# sourceMappingURL=positive.js.map
